<template>
  <el-container class="exam-add">
    <el-main>
      <DsfVirtualScroll>
        <div class="exam-add-main">
          <div class="exam-add-header">
            <h1>{{ title }}</h1>
          </div>
          <el-form @validate="validateQuestions" :model="examQuestions" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
            <div class="exam-select">
              <div class="select-item" :ref="'items'">
                <el-form-item prop="items" label="试题类型 :">
                  <el-select v-if="!readOnly" v-model="examQuestions.items" @change="changeItem" placeholder="请选择" :disabled="disabledItem">
                    <el-option v-for="item in itemsData" :key="item.value" :label="item.text" :value="item"> </el-option>
                  </el-select>
                  <div v-else class="ds-form-readonly">
                    <span class="proxy-text">
                      <span class="proxy-conent" v-if="examQuestions.items">{{ examQuestions.items.text }}</span></span
                    >
                  </div>
                </el-form-item>
              </div>
              <div class="select-item" :ref="'difficulty'">
                <el-form-item prop="difficulty" label="试题难度 :">
                  <el-select v-if="!readOnly" v-model="examQuestions.difficulty" placeholder="请选择">
                    <el-option v-for="item in difficultyData" :key="item.value" :label="item.text" :value="item"> </el-option>
                  </el-select>
                  <div v-else class="ds-form-readonly">
                    <span class="proxy-text">
                      <span class="proxy-conent" v-if="examQuestions.difficulty">{{ examQuestions.difficulty.text }}</span></span
                    >
                  </div>
                </el-form-item>
              </div>
              <div class="select-item exam-labels" :ref="'types'">
                <el-form-item prop="types" label="试题分类 :">
                  <DsfDataChoice
                    :readOnly="readOnly"
                    v-model="examQuestions.types"
                    dialogUrl="exam/questions/types/choose"
                    label="试题分类"
                    :showLabel="false"
                  />
                </el-form-item>
              </div>
              <div
                :class="[
                  'select-item',
                  'exam-labels',
                  {
                    'exam-labels-2': examQuestions.labels && examQuestions.labels.length > 1 && !readOnly,
                  },
                ]"
                :ref="'labels'"
              >
                <el-form-item prop="labels" label="试题标签 :">
                  <DsfDataChoice
                    :readOnly="readOnly"
                    v-model="examQuestions.labels"
                    dialogUrl="exam/labels/choose"
                    label="试题标签"
                    :showLabel="false"
                  />
                </el-form-item>
              </div>
            </div>
            <!-- 题干 -->
            <div class="question-item" ref="name">
              <div class="title-box" slot="label">
                <span class="line-name">题干</span>
                <span class="line-dec" v-if="!readOnly">请在下方输入框填写题干描述
                  <el-button class="insert-blank" v-if="examQuestions['items'] && examQuestions['items'].value == 'input'" @click="insertBlank()">
                    插入填空
                  </el-button>
                </span>
              </div>
              <el-form-item prop="name" label=" ">
                <div @click="showImage" class="readonly-name" v-if="readOnly" v-html="examName(examQuestions)"></div>
                <DsfUEditor
                  v-else
                  :richTxtHeight="200"
                  :readOnly="readOnly"
                  v-model="examQuestions.name"
                  :showLabel="false"
                  :ref="'names'"
                  :readOnlyAutoHeight="true"
                  :toolBar="toolBar"
                />
              </el-form-item>
            </div>

            <component
              v-if="examQuestions.items"
              :itemsData="itemsData"
              :difficultyData="difficultyData"
              :is="componentIs[examQuestions.items.value]"
              :groupSubData="examQuestions['groupSubData']"
              :exam_questions_options="examQuestions['exam_questions_options']"
              :readOnly="readOnly"
              @set-ueditorids="setUeditorIds"
              ref="questions_options"
              @add-show-image="elimage"
              @add-judge="addjudge"
            ></component>

            <!-- 提示 -->
            <div class="question-item" :ref="'hint'" v-show="examQuestions.items && examQuestions.items.value !== 'group'">
              <div class="title-box">
                <span class="line-name">提示</span>
                <span class="line-dec" v-if="!readOnly">请在下方框内填写提示</span>
              </div>
              <el-form-item prop="hint" label=" ">
                <div @click="showImage" class="readonly-name" v-if="readOnly" v-html="examQuestions.hint"></div>
                <DsfUEditor
                  v-else
                  :richTxtHeight="200"
                  :readOnly="readOnly"
                  v-model="examQuestions.hint"
                  :showLabel="false"
                  :ref="'hints'"
                  :readOnlyAutoHeight="true"
                  :toolBar="toolBar"
                />
              </el-form-item>
            </div>
            <!-- 解析 -->
            <div class="question-item" :ref="'parse'" v-show="examQuestions.items && examQuestions.items.value !== 'group'">
              <div class="title-box">
                <span class="line-name">解析</span>
                <span class="line-dec" v-if="!readOnly">请在下方框内填写答案解析</span>
              </div>
              <el-form-item prop="parse" label=" ">
                <div @click="showImage" class="readonly-name" v-if="readOnly" v-html="examQuestions.parse"></div>
                <DsfUEditor
                  v-else
                  :richTxtHeight="200"
                  :readOnly="readOnly"
                  v-model="examQuestions.parse"
                  :showLabel="false"
                  :ref="'parses'"
                  :readOnlyAutoHeight="true"
                  :toolBar="toolBar"
                />
              </el-form-item>
            </div>
          </el-form>
          <el-image v-if="srcList && srcList.length > 0" ref="elimage" :preview-src-list="srcList" class="elimage" />
        </div>
      </DsfVirtualScroll>
    </el-main>
    <el-footer>
      <DsfButton @click="saveQestion('ruleForm')" v-if="!readOnly">保存</DsfButton>
      <DsfButton type="plain" @click="closePage">关闭</DsfButton>
    </el-footer>
  </el-container>
</template>

<script>
import { DsfCombination, DsfCompletion, DsfJudge, DsfMultiple, DsfSingle } from "../components/QuestionItem/index";

export default {
  name: "DsfAddQuestion",
  mixins: [$mixins.examquestion],
  components: {
    DsfCombination,
    DsfCompletion,
    DsfJudge,
    DsfMultiple,
    DsfSingle,
  },
  props: {
    //选择题，填空题选项 是否显示输入字数统计
    showWordLimit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateLength = (rule, value, callback) => {
      if (value) {
        var length = this.getTextLength(value);
        if (length > this.ueditorlength) {
          callback(new Error(`该项长度不超过${this.ueditorlength}字符`));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      showUeditors: false,
      disabledItem: false,
      title: "新增试题",
      ueditorIds: [],
      timer: "",
      componentIs: {
        radio: DsfSingle.name,
        checkbox: DsfMultiple.name,
        judge: DsfJudge.name,
        input: DsfCompletion.name,
        group: DsfCombination.name,
        // subjective: DsfSubject.name,
      },
      readOnly: false,
      examQuestions: {
        difficulty: { text: "简单", value: "1" },
        items: null,
        name: "",
        labels: null,
        types: null,
        parse: "",
        hint: "",
        groupSubData: [],
        exam_questions_options: [],
        exam_questions_id: "",
      },
      // origin_options: [],
      difficultyData: [],
      itemsData: [],
      previtems: "",
      rules: {
        name: [
          { required: true, message: "该项为必填项", trigger: "blur" },
          { validator: validateLength, trigger: "blur" },
        ],
        items: [{ required: true, message: "该项为必填项", trigger: "change" }],
        types: [{ required: true, message: "该项为必填项", trigger: "change" }],
        labels: [{ required: false, message: "该项为必填项", trigger: "change" }],
        difficulty: [{ required: true, message: "该项为必填项", trigger: "change" }],
        groupSubData: [{ required: false, message: "该项为必填项", trigger: "change" }],
        parse: [{ validator: validateLength, trigger: "blur" }],
        hint: [{ validator: validateLength, trigger: "blur" }],
      },
      validateResult: [],
      srcList: [],
    };
  },

  created() {
    //设置默认标签和分类
    var { typeId, typeName, labelId, labelName, isview, id, isnew } = this.$route.query;
    if (isview == "1") {
      this.readOnly = true;
    }
    if (typeId && typeName) {
      this.$nextTick(() => {
        this.examQuestions.types = {
          value: typeId,
          text: typeName,
        };
      });
    }
    if (labelId && labelName) {
      this.$nextTick(() => {
        this.examQuestions.labels = {
          value: labelId,
          text: labelName,
        };
      });
    }
    if (id) {
      this.getMetaData();
      this.disabledItem = true;
      if (isnew != "1" && isview != "1") {
        document.title = "编辑试题";
        this.title = "编辑试题";
      }
      if (isview == "1") {
        document.title = "查看试题";
        this.title = "查看试题";
      }
    }
    if (isview != 1) {
      //试题类型
      this.getDictData("itemsData", "1c3046926b2845f9af826b31b05e00bb");
      //试题难度
      this.getDictData("difficultyData", "96c93538697948258b8e8d5e05d9b49a");
    }
    this.previtems = this.examQuestions.items;
  },
  mounted() {
    if (this.$refs.names) {
      this.ueditorIds.push(this.$refs.names.ueId);
    }
    if (this.$refs.parses) {
      this.ueditorIds.push(this.$refs.parses.ueId);
    }
    if (this.$refs.hints) {
      this.ueditorIds.push(this.$refs.hints.ueId);
    }
    this.timer = setInterval(() => {
      if ($("#" + this.$refs?.names?.ueId).find(".edui-editor-toolbarbox").length > 0) {
        this.showUeditors = true;
        this.ueFocus();
        clearInterval(this.timer);
      }
    }, 300);
  },
  methods: {
    addjudge(newdata) {
      this.examQuestions.exam_questions_options = newdata;
    },
    showImage(e) {
      if (this.readOnly) {
        if (e.target.nodeName.toLowerCase() === "img") {
          this.elimage([e.target.src]);
        }
      }
    },
    elimage(image) {
      this.srcList = image;
      this.$nextTick(() => {
        this.$refs.elimage.showViewer = true;
        $(".el-image-viewer__mask").click(() => {
          this.$refs.elimage.closeViewer();
        });
      });
    },

    validateQuestions(name, ispass, text) {
      if (!ispass) {
        this.validateResult.push({ name, ispass });
      }
    },

    //填空 括号处理
    examName(question) {
      if (question.items && question.items.value == "input") {
        let name = question["name"].replace(/<\/?p>/g, "").replace(/（）|\(\)/g, (word, p) => {
          return "_____ ";
        });
        return name;
      }
      return question["name"];
    },

    //填空 插入括号
    insertBlank() {
      var length = this.examQuestions.exam_questions_options.length;
      if (length < this.maxNumbers) {
        var editor = window.UE.getEditor(this.$refs.names.ueId);
        editor.focus();
        editor.execCommand("inserthtml", "（）");
        this.examQuestions.exam_questions_options.push({
          "exam_questions_options.name": "",
          "exam_questions_options.ds_order": length,
          type: "completion",
        });
      } else {
        dsf.layer.message(`填空数量最多为${this.maxNumbers}个`, false);
        return;
      }
    },

    //验证、保存
    saveQestion(formName) {
      var continues = true;
      //组合题
      if (this.examQuestions.items && this.examQuestions.items.value && this.examQuestions.items.value == "group") {
        var groupSubData = this.$refs.questions_options.groupSubData.filter((item) => item["exam_questions.ds_deleted"] != 1);
        if (groupSubData.length <= 0) {
          dsf.layer.message("请为组合题添加子题", false);
          continues = false;
        } else {
          var combination = this.$refs.questions_options.$refs.combination;
          combination.forEach((element, index) => {
            element.validate((valid) => {
              if (valid) {
                continues = true;
              } else {
                continues = false;
                return false;
              }
            });
          });
        }
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.examQuestions.items.value != "subjective" && this.examQuestions.items.value != "group") {
            this.examQuestions.exam_questions_options = this.$refs.questions_options.exam_questions_options;
            //填空题
            if (this.examQuestions.items.value == "input") {
              var numbers = this.searchTimes(this.examQuestions.name, "（）") + this.searchTimes(this.examQuestions.name, "()");
              var array = this.examQuestions.exam_questions_options.filter((item) => item["exam_questions_options.ds_deleted"] != 1);
              if (numbers == array.length) {
                var canSave = this.$refs.questions_options.save();
                if (canSave) {
                  this.persistData();
                }
              } else {
                dsf.layer.message("填空题答案数量与题目不匹配", false);
                return;
              }
            } else {
              var canSave = this.$refs.questions_options.save();
              if (canSave) {
                this.persistData();
              }
            }
          } else {
            if (continues) {
              if(this.examQuestions.items.value == "subjective"){
                 this.persistData();
              }else{
                var canSave = this.$refs.questions_options.save();
                if (canSave) {
                  this.persistData();
                }
              }
            }
          }
        } else {
          //滚动到错误位置
          setTimeout(() => {
            var err = this.validateResult.find((item) => !item.ispass);
            const top = this.$refs[err.name].getBoundingClientRect().top;
            const scrollTop = document.querySelector(".ds-virtual-scroll-box").scrollTop;
            document.querySelector(".ds-virtual-scroll-box").scrollTo({
              top: top + scrollTop - 60,
              behavior: "smooth",
            });
            return false;
          }, 500);
        }
      });
    },

    getParams() {
      var groupSubData = [];
      var question = this.examQuestions;
      if (this.examQuestions.groupSubData) {
        //设置组合题格式
        var order = 0;
        groupSubData = question.groupSubData.map((item, index) => {
          if (item["exam_questions.ds_deleted"] != 1) {
            order += 1;
          }
          item.exam_questions_options.forEach((ele, _index) => {
            this.$delete(item.exam_questions_options[_index], "type");
          });
          return {
            "exam_questions.difficulty": question.difficulty,
            "exam_questions.labels": question.labels,
            "exam_questions.types": question.types,
            "exam_questions.exam_questions_id": item["exam_questions_id"] || null,
            "exam_questions.hint": item["hint"],
            "exam_questions.items": item["items"],
            "exam_questions.name": item["name"],
            "exam_questions.parse": item["parse"],
            "exam_questions.status": item["status"],
            "exam_questions.treeinfo": item["treeinfo"] || { globalid: null, level: null, pid: null },
            exam_questions_options: item["exam_questions_options"],
            "exam_questions.ds_deleted": item["exam_questions.ds_deleted"] || 0,
            "exam_questions.ds_order": order,
            _id: item["_id"] || null,
          };
        });
      }
      this.examQuestions.exam_questions_options.forEach((ele, index) => {
        this.$delete(this.examQuestions.exam_questions_options[index], "type");
      });
      var data = {
        _id: this.$route.query.id,
        "exam_questions.exam_questions_id": this.$route.query.id,
        "exam_questions.status": { text: "启用", value: "1" },
        "exam_questions.name": question.name,
        "exam_questions.types": question.types,
        "exam_questions.items": question.items,
        "exam_questions.labels": question.labels,
        exam_questions_options: question.exam_questions_options,
        "exam_questions.difficulty": question.difficulty,
        "exam_questions.hint": question.hint,
        "exam_questions.parse": question.parse,
        "exam_questions.treeinfo": question["treeinfo"] || { globalid: null, level: null, pid: null },
        exam_questions: [],
      };
      if (question.items.value == "group") {
        this.$set(data, "exam_questions.groupSubData", groupSubData);
      }
      // console.log("data", data);
      return {
        namespace: "exam.questions",
        pageName: "edit",
        data: JSON.stringify(data),
        attach: {},
      };
    },

    //保存请求
    persistData() {
      var loading = dsf.layer.loading();
      var params = this.getParams();
      this.$http
        .post("meta/persistData", params, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            this.$router.replace({
              path: this.$route.path,
              query: { id: res.data._id, ...this.$route.query },
            });
            dsf.layer.message("保存成功", true);
            setTimeout(() => {
              dsf.layer.closeLoading(loading);
              location.reload();
            }, 700);
            this.getMetaData();
            if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
              this.$openerVm = window.opener.openerVms[window.name] || null;
              this.$openerVm?.reloadData();
            }
          } else {
            dsf.layer.closeLoading(loading);
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },

    //初始化数据
    getMetaData() {
      var loading = dsf.layer.loading();
      var params = {
        id: this.$route.query.id,
        pageName: "edit",
        namespace: "exam.questions",
        data: JSON.stringify({ _id: this.$route.query.id }),
      };
      this.$http
        .get("meta/data", params, $$webRoot.exam)
        .done((res) => {
          if (res.success && res.data["exam_questions.items"]) {
            var data = res.data;
            var groupSubData = [];
            if (data["exam_questions.groupSubData"]) {
              groupSubData = data["exam_questions.groupSubData"]
                .map((item) => {
                  return {
                    difficulty: item["exam_questions.difficulty"],
                    hint: item["exam_questions.hint"],
                    items: item["exam_questions.items"],
                    labels: item["exam_questions.labels"],
                    name: item["exam_questions.name"],
                    parse: item["exam_questions.parse"],
                    types: item["exam_questions.types"],
                    exam_questions_options: item["exam_questions_options"],
                    status: item["exam_questions.status"],
                    treeinfo: item["exam_questions.treeinfo"],
                    exam_questions_id: item["exam_questions.exam_questions_id"],
                    _id: item["_id"],
                    "exam_questions.ds_deleted": item["exam_questions.ds_deleted"],
                    "exam_questions.ds_order": item["exam_questions.ds_order"],
                  };
                })
                .sort((ele, item) => {
                  return ele["exam_questions.ds_order"] - item["exam_questions.ds_order"];
                });
              //排序
            }
            this.$nextTick(() => {
              this.examQuestions = {
                difficulty: data["exam_questions.difficulty"],
                items: data["exam_questions.items"],
                name: data["exam_questions.name"],
                labels: data["exam_questions.labels"],
                types: data["exam_questions.types"],
                parse: data["exam_questions.parse"],
                hint: data["exam_questions.hint"],
                groupSubData,
                exam_questions_id: data.exam_questions_id,
                exam_questions_options: data["exam_questions_options"] ? data["exam_questions_options"] : [],
              };
              // this.origin_options= data["exam_questions_options"];
              this.previtems = this.examQuestions.items;
            });
          } else {
            dsf.layer.message("请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },

    closePage() {
      if (this.$dialog) {
        this.$dialog.close();
      } else {
        window.close();
      }
    },

    //修改试题类型
    changeItem(val) {
      var message = "确定要修改试题类型吗？修改类型后选项将会重置。";
      if (!this.previtems) {
        this.previtems = this.examQuestions.items;
      }
      if (this.previtems.value === "group") {
        message = "确定要修改试题类型吗？修改类型后组合题的子题将会重置。";
      }
      if (this.examQuestions.exam_questions_options?.length > 0 || this.examQuestions.groupSubData.length > 0) {
        dsf.layer
          .confirm(message, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            //确认
            this.previtems = this.examQuestions.items;
            this.examQuestions.exam_questions_options = [];
            this.examQuestions.groupSubData = [];
          })
          .catch(() => {
            //取消
            this.examQuestions.items = this.previtems;
          });
      }
    },

    //数据字典
    getDictData(name, id) {
      var loading = dsf.layer.loading();
      this.$http
        .get("/dict/getList/" + id, {}, $$webRoot.exam)
        .done((res) => {
          if (res.success) {
            this.$nextTick(() => {
              var data = res.data;
              this[name] = data.map((item) => {
                return { text: item.text, value: item.value };
              });
            });
          } else {
            dsf.layer.message(res.message || "请求异常", false);
          }
        })
        .error((err) => {
          dsf.layer.message((err && err.message) || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },

    //查找指定字符
    searchTimes(text, word) {
      var index = text.indexOf(word);
      var num = 0;
      while (index !== -1) {
        num++;
        index = text.indexOf(word, index + 1);
      }
      return num;
    },

    //查找页面所有富文本编辑器
    setUeditorIds(arr) {
      this.ueditorIds = arr; //子题中的富文本编辑器
      if (this.$refs.names) {
        this.ueditorIds.push(this.$refs.names.ueId);
      }
      if (this.$refs.parses) {
        this.ueditorIds.push(this.$refs.parses.ueId);
      }
      if (this.$refs.hints) {
        this.ueditorIds.push(this.$refs.hints.ueId);
      }
      this.ueFocus();
    },

    //监听富文本编辑器focus事件
    ueFocus() {
      this.ueditorIds.forEach((item) => {
        //隐藏工具栏
        $("#" + item)
          .find(".edui-editor-toolbarbox")
          .addClass("edui-editor-toolbarboxnone");
        window.UE.getEditor(item).addListener("focus", (editor) => {
          this.setEditor(item);
        });
        setTimeout(() => {
          var iframes = document.getElementsByTagName("iframe");
          iframes.forEach((element) => {
            if (element.id) {
              $("#" + element.id)
                .contents()
                .find("body")
                .css({ height: "50px" });
              $("#" + element.id)
                .contents()
                .find("body.empty")
                .css({ height: "50px" });
            }
          });
        }, 500);
      });
    },

    //富文本编辑器
    setEditor(activeId) {
      _.forEach(this.ueditorIds, (item) => {
        if (item === activeId) {
          $("#" + item + " " + ".edui-editor").css("height", "auto");
          $("#" + item)
            .find(".edui-editor-toolbarbox")
            .removeClass("edui-editor-toolbarboxnone");
          $("#" + item)
            .find(".edui-editor-bottomContainer")
            .show();
          [...$("#" + item + " iframe")].forEach((element) => {
            if (element.id) {
              $("#" + element.id)
                .contents()
                .find("body")
                .css({ display: "block", height: "190px" });
            }
          });
        } else {
          [...$("#" + item + " iframe")].forEach((element) => {
            if (element.id) {
              $("#" + element.id)
                .contents()
                .find("body.empty")
                .css({ height: "50px" });
            }
          });
          $("#" + item + " " + ".edui-editor").css("height", "50px");
          $("#" + item)
            .find(".edui-editor-toolbarbox")
            .addClass("edui-editor-toolbarboxnone");
          $("#" + item)
            .find(".edui-editor-bottomContainer")
            .hide();
        }
      });
    },
  },
};
</script>

<style></style>
